// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_orderModal__On4U2 {
  padding: 0;
}
.styles_orderModal__On4U2 .modal__inner {
  height: 100%;
  border-radius: 0;
  max-width: none;
  display: flex;
  flex-direction: column;
  height: 100%;
}
.styles_orderModal__On4U2 .modal__inner .modal__header {
  padding: 24px 16px;
  border: none;
}
.styles_orderModal__On4U2 .modal__inner .modal__body {
  background: #FFF;
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: auto;
  padding: 0;
}
.styles_orderModal__On4U2 .modal__inner .modal__body .submitBlock {
  margin-top: auto;
}
.styles_orderModal__On4U2 .options-list {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
@media (max-width: 1200px) {
  .styles_orderModal__On4U2 .options-list {
    gap: 24px;
  }
}
.styles_orderModal__On4U2 .checkbox-row p, .styles_orderModal__On4U2 .radio-row p {
  line-height: 114%;
  border: none;
}
.styles_orderModal__On4U2 .styles_modal-text__XKp0h {
  font-size: 14px;
  line-height: 20px;
  color: #54575C;
}
.styles_orderModal__swipeHandler__-h3ls {
  position: absolute;
  top: -10px;
  left: 50%;
  transform: translateX(-50%);
  width: 100%;
  height: 2px;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2;
}
.styles_orderModal__swipeHandler__-h3ls span {
  border-radius: 8px;
  background: #FFF;
  width: 88px;
  height: 2px;
  z-index: 2;
  display: block;
  position: relative;
}
.styles_orderModal__swipeHandler__-h3ls::before {
  content: "";
  position: absolute;
  bottom: -5vh;
  left: 0;
  right: 0;
  width: 100%;
  height: 30vh;
  background: transparent;
}
.styles_orderModal__top__XfjsF {
  width: 100%;
  min-height: 216px;
  height: 55vw;
  max-height: 420px;
  border-radius: 16px 16px 0 0;
  overflow: hidden;
}
.styles_orderModal__top__XfjsF .swiper {
  height: 100%;
}
.styles_orderModal__top__XfjsF .swiper-pagination-bullet {
  width: 6px;
  height: 6px;
  margin: 0 6px;
  background: #D9D9D9;
  opacity: 0.4;
}
.styles_orderModal__top__XfjsF .swiper-pagination-bullet-active {
  background: #FAFAFA;
  opacity: 1;
}
.styles_orderModal__top__XfjsF .swiper-slide {
  width: 100%;
}
.styles_orderModal__top__XfjsF .swiper-slide img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
}
.styles_orderModal__roundedTop__gm0\\+I {
  border-radius: 16px 16px 0 0;
}
.styles_orderModal__body__TTwMb {
  display: flex;
  flex-direction: column;
  gap: 16px;
  border-radius: 16px 16px 0 0;
  padding: 0 16px;
}
.styles_orderModal__body_load__3OQkQ {
  gap: initial;
}
.styles_orderModal__block__jBEcc {
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin-bottom: 5px;
}
@media (min-width: 1200px) {
  .styles_orderModal__block__jBEcc {
    margin-bottom: 24px;
  }
}
.styles_orderModal__blockTitle__UsqbI {
  font-size: 16px;
  font-weight: 500;
  line-height: 114%;
  padding-bottom: 4px;
}
@media (min-width: 640px) {
  .styles_orderModal__blockTitle__UsqbI {
    font-size: 22px;
  }
}
@media (min-width: 1200px) {
  .styles_orderModal__blockTitle__UsqbI {
    font-size: var(--fz-lg);
    line-height: var(--lh-lg);
  }
}
.styles_orderModal__blockTitle__UsqbI::first-letter {
  text-transform: capitalize;
}
.styles_orderModal__blockRequired__jKtsS {
  color: #f2200d;
}
.styles_orderModal__submitBlock__jJxeN {
  padding: 16px;
  bottom: 0;
  left: 50%;
  background: #FFF;
  z-index: 2;
  position: sticky;
  width: 100%;
}
.styles_orderModal__submitBlockHead__Hd8mi {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.styles_orderModal__submitBlockHead__Hd8mi h5 {
  color: #151B26;
  line-height: 114%;
  font-size: 14px;
  font-weight: 600;
}
.styles_orderModal__submitBlockHead__Hd8mi p {
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 114%;
  letter-spacing: -0.24px;
}
.styles_orderModal__submitBlockBottom__XNHxK {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 12px;
}
.styles_orderModal__calc__NPqWj {
  height: 44px;
  width: 88px;
  min-width: 88px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 12px;
  background: #EEE;
  margin-right: 12px;
}
.styles_orderModal__calcPlus__6AYWk, .styles_orderModal__calcMinus__BkfMy {
  width: 16px;
  height: 20px;
  display: flex;
  align-items: center;
}
.styles_orderModal__calcPlus__6AYWk:disabled, .styles_orderModal__calcMinus__BkfMy:disabled {
  opacity: 0.5;
}
.styles_orderModal__calcNum__BQMkR {
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px;
  color: #000;
  width: 32px;
  margin: 0 4px;
  text-align: center;
}
.styles_orderModal__picker__DcQkc {
  width: 100%;
  position: relative;
}
.styles_orderModal__picker__DcQkc img {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: 10px;
}
@media (min-width: 640px) {
  .styles_orderModal__picker__DcQkc img {
    right: 20px;
    width: 32px;
    height: 32px;
  }
}
@media (min-width: 1200px) {
  .styles_orderModal__picker__DcQkc img {
    width: 22px;
    height: 22px;
    right: 10px;
  }
}
.styles_orderModal__picker__DcQkc input[type=date]::-webkit-inner-spin-button,
.styles_orderModal__picker__DcQkc input[type=datetime-local]::-webkit-inner-spin-button,
.styles_orderModal__picker__DcQkc input[type=date]::-webkit-calendar-picker-indicator,
.styles_orderModal__picker__DcQkc input[type=datetime-local]::-webkit-calendar-picker-indicator {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
  -webkit-appearance: none;
}
.styles_orderModal__picker__DcQkc input[type=date], .styles_orderModal__picker__DcQkc input[type=datetime-local] {
  -webkit-appearance: none;
  width: -webkit-fill-available;
}
.styles_orderModal__picker__DcQkc input[type=date]:not(.styles_has_value__GS-kq):before,
.styles_orderModal__picker__DcQkc input[type=datetime-local]:not(.styles_has_value__GS-kq):before {
  content: attr(placeholder);
  color: #BEC0C2;
  width: 100%;
}
.styles_orderModal__picker__DcQkc input[type=date]::after,
.styles_orderModal__picker__DcQkc input[type=datetime-local]::after {
  position: absolute;
  right: 0;
  content: "";
  width: 20px;
  height: 100%;
  background: white;
  border-radius: 8px;
  border-radius: 8px;
}
.styles_orderModal__picker__DcQkc input {
  width: 100%;
  height: 40px;
  border-radius: 8px;
  border: 1px solid #E8ECEE;
  background: #FFF;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  padding: 3px 10px;
  position: relative;
}
@media (min-width: 640px) {
  .styles_orderModal__picker__DcQkc input {
    height: 64px;
    padding-left: 32px;
    font-size: 20px;
  }
}
@media (min-width: 1200px) {
  .styles_orderModal__picker__DcQkc input {
    height: 38px;
    padding-left: 10px;
    font-size: var(--fz-md);
    line-height: normal;
  }
}
.styles_orderModal__picker__DcQkc input::placeholder {
  color: #BEC0C2;
}
.styles_orderModal__picker__DcQkc .react-datepicker-wrapper {
  width: 100%;
}
.styles_orderModal__sk1__9L5dA, .styles_orderModal__sk2__pxthQ, .styles_orderModal__sk3__IzHAF, .styles_orderModal__sk4__HNE-Y {
  border-radius: 2px;
  height: 13px;
  width: 100%;
  margin-top: 8px;
}
.styles_orderModal__sk2__pxthQ {
  width: 85%;
  margin-top: 10px;
}
.styles_orderModal__sk3__IzHAF {
  width: 50%;
  margin-top: 10px;
}
.styles_orderModal__sk4__HNE-Y {
  width: 20%;
  margin-top: 16px;
  margin-bottom: 9px;
}
.styles_orderModal__sk5__hCBms {
  margin-top: 4px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-left: 4px;
  padding-top: 4px;
  padding-bottom: 12px;
  border-bottom: 1px solid #F3F2F2;
}
.styles_orderModal__sk5__hCBms span {
  width: 14px;
  height: 14px;
  border-radius: 50%;
  display: block;
  margin-top: 4px;
  margin-bottom: 4px;
}
.styles_orderModal__sk5__hCBms div {
  border-radius: 2px;
  height: 14px;
  width: calc(100% - 34px);
}
.styles_orderModal__info__M87-b {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.styles_orderModal__infoTitle__06LKb {
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 144%;
  color: var(--text-color);
}
.styles_orderModal__infoText__06jra {
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 144%;
  word-wrap: break-word;
}
.styles_orderModal__infoText__06jra a {
  color: var(--accent-color);
  text-decoration: underline;
}
.styles_orderModal__infoText__06jra ul, .styles_orderModal__infoText__06jra ol {
  margin: 0;
  padding: 0;
  padding-left: 16px;
}
.styles_orderModal__infoText__06jra img {
  max-width: 100%;
}
.styles_orderModal__infoText__06jra table {
  border-collapse: collapse;
  table-layout: fixed;
  width: 100%;
  margin: 0;
  overflow: hidden;
}
.styles_orderModal__infoText__06jra table td, .styles_orderModal__infoText__06jra table th {
  min-width: 1em;
  border: 2px solid #ced4da;
  padding: 3px 5px;
  vertical-align: top;
  box-sizing: border-box;
  position: relative;
}
.styles_orderModal__infoText__06jra table td > *, .styles_orderModal__infoText__06jra table th > * {
  margin-bottom: 0;
}
.styles_orderModal__infoText__06jra table th {
  font-weight: 700;
  text-align: left;
  background-color: #f1f3f5;
}
.styles_orderModal__infoText__06jra p {
  min-height: 20px;
}
.styles_orderModal__infoText__06jra h1, .styles_orderModal__infoText__06jra h2, .styles_orderModal__infoText__06jra h3 {
  color: #303030;
}
.styles_orderModal__infoText__06jra pre {
  background: #2b2a2a;
  color: #fff;
  padding: 8px;
  display: flex;
  border-radius: 8px;
  width: 100%;
  white-space: pre-wrap;
}
.styles_orderModal__infoText__06jra code {
  width: 100%;
  display: block;
  color: #fff;
  background-color: #f1f3f5;
}
.styles_orderModal__files__LnGzv {
  padding-top: 8px;
}
.styles_orderModal__files__LnGzv .orderModal__file {
  flex-direction: row;
  flex-wrap: nowrap;
  padding: 8px 32px 8px 4px;
  border-radius: 12px;
  border: 1px solid transparent;
  display: flex;
  align-items: center;
  gap: 8px;
  position: relative;
  transition: var(--transition);
  margin-bottom: 8px;
}
.styles_orderModal__files__LnGzv .orderModal__file img {
  width: 15px;
  height: 21px;
}
.styles_orderModal__file__nn\\+Qh {
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  gap: 2px;
  margin-bottom: 8px;
  padding: 8px 32px 8px 4px;
  background: var(--white);
  border-radius: 12px;
  border: 1px solid transparent;
  position: relative;
  transition: var(--transition);
}
@media (hover: hover) {
  .styles_orderModal__file__nn\\+Qh:hover {
    border-color: var(--accent-color);
  }
}
.styles_orderModal__fileContent__0wwD7 {
  display: flex;
  align-items: center;
  gap: 8px;
  transition: var(--transition);
}
.styles_orderModal__fileContent__0wwD7 img {
  max-width: 24px;
  min-width: 24px;
}
.styles_orderModal__fileIsLoading__loader__Hdhih {
  height: 3px;
  background: #4084F8;
}
.styles_orderModal__fileName__W\\+QOa {
  font-size: var(--fz-md);
  line-height: var(--lh-md);
}
.styles_orderModal__fileSize__nmoTc {
  font-size: var(--fz-sm);
  line-height: 1;
  color: #7A808B;
  margin-top: 2px;
}
.styles_orderModal__fileDelete__NtCSF {
  margin-left: auto;
  color: var(--error);
}
.styles_orderModal__object__RfzNV {
  border-radius: 12px;
  background: #FAFAFA;
  padding: 8px;
  display: flex;
  align-items: center;
}
.styles_orderModal__objectIco__Gjc9a {
  width: 26px;
  min-width: 26px;
  height: 26px;
  margin-right: 8px;
}
.styles_orderModal__objectText__PmtL- span {
  font-size: 14px;
  line-height: 114%;
  color: #7A808B;
}
.styles_orderModal__objectText__PmtL- p {
  font-size: 16px;
  color: #101618;
  line-height: 23.04px;
}
.styles_orderModal__objectArrow__FTppE {
  margin-left: auto;
}
@media (min-width: 640px) {
  .styles_orderModal__top__XfjsF .swiper-pagination {
    bottom: 24px;
  }
  .styles_orderModal__top__XfjsF .swiper-pagination-bullet {
    width: 12px;
    height: 12px;
    margin: 0 12px;
    background: #D9D9D9;
    opacity: 0.4;
  }
  .styles_orderModal__top__XfjsF .swiper-pagination-bullet-active {
    background: #FAFAFA;
    opacity: 1;
  }
  .styles_orderModal__body__TTwMb {
    padding: 16px 24px 0;
  }
  .styles_orderModal__submitBlock__jJxeN {
    padding: 24px;
    margin-left: -24px;
  }
  .styles_orderModal__submitBlockHead__Hd8mi h5 {
    font-size: 32px;
  }
  .styles_orderModal__submitBlockHead__Hd8mi p {
    font-size: 28px;
    letter-spacing: -0.56px;
  }
  .styles_orderModal__submitBlockBottom__XNHxK {
    margin-top: 18px;
  }
  .styles_orderModal__calc__NPqWj {
    border-radius: 16px;
    width: 195px;
    min-width: 195px;
    height: 76px;
    margin-right: 16px;
  }
  .styles_orderModal__calcNum__BQMkR {
    width: 59px;
    height: 22px;
    margin: 0 16px;
    font-size: 28px;
  }
  .styles_orderModal__calcPlus__6AYWk, .styles_orderModal__calcMinus__BkfMy {
    width: 32px;
    height: 32px;
  }
  .styles_orderModal__calcPlus__6AYWk svg, .styles_orderModal__calcMinus__BkfMy svg {
    width: 32px;
    height: 32px;
  }
}
.styles_orderModal__inputError__KPVxs.styles_orderModal__inputError__KPVxs {
  border-color: #F2200D;
}
.styles_orderModal__time__n-Ko9 {
  font-size: 12px;
  padding: 2px 4px;
  min-height: auto;
}

.styles_photoBlock__UY68P {
  display: grid;
  grid-gap: 8px;
  grid-template-columns: repeat(3, 1fr);
}
@media (min-width: 1200px) {
  .styles_photoBlock__UY68P {
    grid-template-columns: repeat(6, 1fr);
  }
}
.styles_photoBlock__append__UiuDU {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  height: 105px;
  cursor: pointer;
  background: rgba(var(--accent-color-rgb), 0.1);
}
.styles_photoBlock__append__UiuDU.styles_error__25j67 {
  border: 1px solid #F2200D;
}
.styles_photoBlock__plus__4qG7t {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: var(--accent-color);
  color: var(--accent-text-color);
  position: absolute;
  top: 8px;
  right: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.styles_photoBlock__preview__OTEa6 {
  height: 105px;
  border-radius: 8px;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}
.styles_photoBlock__preview__OTEa6 > img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
}
.styles_photoBlock__close__6-S9E {
  position: absolute;
  top: 8px;
  right: 8px;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1;
  background: #E97676;
}
@media (min-width: 640px) {
  .styles_photoBlock__append__UiuDU, .styles_photoBlock__preview__OTEa6 {
    height: 140px;
  }
}
@media (min-width: 1200px) {
  .styles_photoBlock__append__UiuDU, .styles_photoBlock__preview__OTEa6 {
    height: 104px;
  }
}
.styles_photoBlock__camera__oyviF {
  color: rgba(var(--accent-color-rgb), 0.45);
}

@media (min-width: 1200px) {
  label.styles_checkboxAlone__0iloR {
    flex-direction: row-reverse;
    justify-content: flex-end;
    padding-left: 0;
  }
}
@media (min-width: 1200px) {
  label.styles_checkboxAlone__0iloR p {
    width: auto;
    font-weight: 500;
    font-size: var(--fz-lg);
    line-height: var(--lh-lg);
    padding-top: 5px;
    margin-right: 8px;
  }
}

@media (min-width: 1200px) {
  .styles_orderModal__block__jBEcc .styles_checkboxAlone__0iloR p:last-child {
    margin-left: 0;
  }
}

.styles_conditionList__PCqEU {
  position: initial;
  overflow: hidden;
  transition: 0.15s;
}

.styles_conditionList__container__5kG-A {
  display: flex;
  flex-direction: column;
}
@media (max-width: 1200px) {
  .styles_conditionList__container__5kG-A {
    gap: 24px;
  }
}

.styles_qrBlock__u-\\+9B {
  padding: 10px;
  border-radius: 8px;
  font-size: 14px;
  line-height: 20px;
  display: flex;
  align-items: center;
  gap: 8px;
  background: #EAF7EF;
  width: max-content;
  cursor: pointer;
}
.styles_qrBlock__u-\\+9B svg {
  width: 13px;
  height: 13px;
}
.styles_qrBlock__u-\\+9B svg path {
  fill: #2DBE64;
}

.styles_QRInput__KjW\\+e {
  position: relative;
}
.styles_QRInput__KjW\\+e input:disabled {
  background: none;
}
.styles_QRInput__icon__dpmkP {
  position: absolute;
  top: calc(50% - 16px);
  right: 10px;
  background: none;
}`, "",{"version":3,"sources":["webpack://./src/components/Modals/OrderModal/OrderModal.module.scss","webpack://./src/components/Modals/ChatModal/assets/styles.module.scss"],"names":[],"mappings":"AAAA;EACE,UAAA;ACCF;ADEI;EACE,YAAA;EACA,gBAAA;EACA,eAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;ACAN;ADEM;EACE,kBAAA;EACA,YAAA;ACAR;ADGM;EACE,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;EACA,cAAA;EACA,UAAA;ACDR;ADGQ;EACE,gBAAA;ACDV;ADMI;EACE,aAAA;EACA,sBAAA;EACA,SAAA;ACJN;ADMM;EALF;IAMI,SAAA;ECHN;AACF;ADOM;EACE,iBAAA;EACA,YAAA;ACLR;ADUE;EACE,eAAA;EACA,iBAAA;EACA,cAAA;ACRJ;ADWE;EACE,kBAAA;EACA,UAAA;EACA,SAAA;EACA,2BAAA;EACA,WAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,UAAA;ACTJ;ADUI;EACE,kBAAA;EACA,gBAAA;EACA,WAAA;EACA,WAAA;EACA,UAAA;EACA,cAAA;EACA,kBAAA;ACRN;ADUI;EACE,WAAA;EACA,kBAAA;EACA,YAAA;EACA,OAAA;EACA,QAAA;EACA,WAAA;EACA,YAAA;EACA,uBAAA;ACRN;ADYE;EACE,WAAA;EACA,iBAAA;EACA,YAAA;EACA,iBAAA;EACA,4BAAA;EACA,gBAAA;ACVJ;ADaM;EACE,YAAA;ACXR;ADaU;EACE,UAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,YAAA;ACXZ;ADaY;EACE,mBAAA;EACA,UAAA;ACXd;ADgBQ;EACE,WAAA;ACdV;ADeU;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,uBAAA;ACbZ;ADoBE;EACE,4BAAA;AClBJ;ADqBE;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,4BAAA;EACA,eAAA;ACnBJ;ADqBI;EACE,YAAA;ACnBN;ADsBE;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,kBAAA;ACpBJ;ADsBI;EANF;IAOI,mBAAA;ECnBJ;AACF;ADsBE;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;ACpBJ;ADsBI;EANF;IAOI,eAAA;ECnBJ;AACF;ADqBI;EAVF;IAWI,uBAAA;IACA,yBAAA;EClBJ;AACF;ADoBI;EACE,0BAAA;AClBN;ADsBE;EACE,cAAA;ACpBJ;ADuBE;EACE,aAAA;EACA,SAAA;EACA,SAAA;EACA,gBAAA;EACA,UAAA;EACA,gBAAA;EACA,WAAA;ACrBJ;ADwBE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;ACtBJ;ADuBI;EACE,cAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;ACrBN;ADuBI;EACE,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,uBAAA;ACrBN;ADyBE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,gBAAA;ACvBJ;AD0BE;EACE,YAAA;EACA,WAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;ACxBJ;AD2BE;EAEE,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;AC1BJ;AD2BI;EACE,YAAA;ACzBN;AD6BE;EACE,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,WAAA;EACA,WAAA;EACA,aAAA;EACA,kBAAA;AC3BJ;AD8BE;EACE,WAAA;EACA,kBAAA;AC5BJ;AD8BI;EACE,kBAAA;EACA,QAAA;EACA,2BAAA;EACA,WAAA;AC5BN;AD8BM;EANF;IAOI,WAAA;IACA,WAAA;IACA,YAAA;EC3BN;AACF;AD6BM;EAZF;IAaI,WAAA;IACA,YAAA;IACA,WAAA;EC1BN;AACF;AD6BI;;;;EAIE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,wBAAA;AC3BN;AD8BK;EACC,wBAAA;EACA,6BAAA;AC5BN;ADgCI;;EAEE,0BAAA;EACA,cAAA;EACA,WAAA;AC9BN;ADkCI;;EAEE,kBAAA;EACA,QAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;AChCN;ADqCI;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,iBAAA;EACA,kBAAA;ACnCN;ADqCM;EAbF;IAcI,YAAA;IACA,kBAAA;IACA,eAAA;EClCN;AACF;ADoCM;EAnBF;IAoBI,YAAA;IACA,kBAAA;IACA,uBAAA;IACA,mBAAA;ECjCN;AACF;ADmCM;EACE,cAAA;ACjCR;ADsCM;EACE,WAAA;ACpCR;ADyCE;EAIE,kBAAA;EACA,YAAA;EACA,WAAA;EACA,eAAA;AC1CJ;AD6CE;EACE,UAAA;EACA,gBAAA;AC3CJ;AD8CE;EACE,UAAA;EACA,gBAAA;AC5CJ;AD+CE;EACE,UAAA;EACA,gBAAA;EACA,kBAAA;AC7CJ;ADgDE;EACE,eAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,iBAAA;EACA,gBAAA;EACA,oBAAA;EACA,gCAAA;AC9CJ;AD+CI;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;AC7CN;ADgDI;EACE,kBAAA;EACA,YAAA;EACA,wBAAA;AC9CN;ADkDE;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AChDJ;ADmDE;EACE,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,wBAAA;ACjDJ;ADoDE;EACE,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,qBAAA;AClDJ;ADoDI;EACE,0BAAA;EACA,0BAAA;AClDN;ADoDI;EACE,SAAA;EACA,UAAA;EACA,kBAAA;AClDN;ADqDI;EACE,eAAA;ACnDN;ADqDI;EACE,yBAAA;EACA,mBAAA;EACA,WAAA;EACA,SAAA;EACA,gBAAA;ACnDN;ADsDI;EACE,cAAA;EACA,yBAAA;EACA,gBAAA;EACA,mBAAA;EACA,sBAAA;EACA,kBAAA;ACpDN;ADuDI;EACE,gBAAA;ACrDN;ADwDI;EACE,gBAAA;EACA,gBAAA;EACA,yBAAA;ACtDN;ADyDI;EACE,gBAAA;ACvDN;AD0DI;EAGE,cAAA;AC1DN;AD4DI;EACE,mBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;EACA,WAAA;EACA,qBAAA;AC1DN;AD4DI;EACE,WAAA;EACA,cAAA;EACA,WAAA;EACA,yBAAA;AC1DN;AD8DE;EACE,gBAAA;AC5DJ;ADgEQ;EACE,mBAAA;EACA,iBAAA;EACA,yBAAA;EACA,mBAAA;EACA,6BAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;EACA,kBAAA;EACA,6BAAA;EACA,kBAAA;AC9DV;ADgEU;EACE,WAAA;EACA,YAAA;AC9DZ;ADqEE;EACE,aAAA;EACA,sBAAA;EACA,eAAA;EACA,QAAA;EACA,kBAAA;EACA,yBAAA;EACA,wBAAA;EACA,mBAAA;EACA,6BAAA;EACA,kBAAA;EACA,6BAAA;ACnEJ;ADqEI;EACE;IACE,iCAAA;ECnEN;AACF;ADuEE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,6BAAA;ACrEJ;ADuEI;EACE,eAAA;EACA,eAAA;ACrEN;AD0EI;EACE,WAAA;EACA,mBAAA;ACxEN;AD4EE;EACE,uBAAA;EACA,yBAAA;AC1EJ;AD6EE;EACE,uBAAA;EACA,cAAA;EACA,cAAA;EACA,eAAA;AC3EJ;AD8EE;EACE,iBAAA;EACA,mBAAA;AC5EJ;AD+EE;EACE,mBAAA;EACA,mBAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;AC7EJ;AD+EE;EACE,WAAA;EACA,eAAA;EACA,YAAA;EACA,iBAAA;AC7EJ;ADgFI;EACE,eAAA;EACA,iBAAA;EACA,cAAA;AC9EN;ADiFI;EACE,eAAA;EACA,cAAA;EACA,oBAAA;AC/EN;ADmFE;EACE,iBAAA;ACjFJ;ADoFE;EAKQ;IACE,YAAA;ECtFV;EDuFU;IACE,WAAA;IACA,YAAA;IACA,cAAA;IACA,mBAAA;IACA,YAAA;ECrFZ;EDuFY;IACE,mBAAA;IACA,UAAA;ECrFd;ED6FE;IACE,oBAAA;EC3FJ;ED8FE;IACE,aAAA;IACA,kBAAA;EC5FJ;EDgGI;IACE,eAAA;EC9FN;EDiGI;IACE,eAAA;IACA,uBAAA;EC/FN;EDmGE;IACE,gBAAA;ECjGJ;EDoGE;IACE,mBAAA;IACA,YAAA;IACA,gBAAA;IACA,YAAA;IACA,kBAAA;EClGJ;EDqGE;IACE,WAAA;IACA,YAAA;IACA,cAAA;IACA,eAAA;ECnGJ;EDsGE;IAEE,WAAA;IACA,YAAA;ECrGJ;EDsGI;IACE,WAAA;IACA,YAAA;ECpGN;AACF;ADuGE;EACE,qBAAA;ACrGJ;ADwGE;EACE,eAAA;EACA,gBAAA;EACA,gBAAA;ACtGJ;;AD0GA;EACE,aAAA;EACA,aAAA;EACA,qCAAA;ACvGF;ADyGE;EALF;IAMI,qCAAA;ECtGF;AACF;ADwGE;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,aAAA;EACA,eAAA;EACA,8CAAA;ACtGJ;ADwGI;EACE,yBAAA;ACtGN;AD0GE;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,+BAAA;EACA,+BAAA;EACA,kBAAA;EACA,QAAA;EACA,UAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;ACxGJ;AD2GE;EACE,aAAA;EACA,kBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;ACzGJ;AD2GI;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,uBAAA;ACzGN;AD6GE;EACE,kBAAA;EACA,QAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,UAAA;EACA,mBAAA;AC3GJ;ADgHI;EAFF;IAGI,aAAA;EC7GJ;AACF;AD+GI;EANF;IAOI,aAAA;EC5GJ;AACF;AD+GE;EACE,0CAAA;AC7GJ;;ADkHE;EADF;IAEI,2BAAA;IACA,yBAAA;IACA,eAAA;EC9GF;AACF;ADiHI;EADF;IAEI,WAAA;IACA,gBAAA;IACA,uBAAA;IACA,yBAAA;IACA,gBAAA;IACA,iBAAA;EC9GJ;AACF;;ADuHU;EADF;IAEI,cAAA;ECnHV;AACF;;AD0HA;EACE,iBAAA;EACA,gBAAA;EACA,iBAAA;ACvHF;;AD0HA;EACE,aAAA;EACA,sBAAA;ACvHF;ADyHE;EAJF;IAKI,SAAA;ECtHF;AACF;;ADyHA;EACE,aAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;ACtHF;ADwHE;EACE,WAAA;EACA,YAAA;ACtHJ;ADwHI;EACE,aAAA;ACtHN;;AD2HA;EACE,kBAAA;ACxHF;AD0HE;EACE,gBAAA;ACxHJ;AD2HE;EACE,kBAAA;EACA,qBAAA;EACA,WAAA;EACA,gBAAA;ACzHJ","sourcesContent":[".orderModal {\n  padding: 0;\n\n  :global {\n    .modal__inner {\n      height: 100%;\n      border-radius: 0;\n      max-width: none;\n      display: flex;\n      flex-direction: column;\n      height: 100%;\n\n      .modal__header {\n        padding: 24px 16px;\n        border: none;\n      }\n\n      .modal__body {\n        background: #FFF;\n        display: flex;\n        flex-direction: column;\n        height: 100%;\n        overflow: auto;\n        padding: 0;\n\n        .submitBlock {\n          margin-top: auto;\n        }\n      }\n    }\n\n    .options-list {\n      display: flex;\n      flex-direction: column;\n      gap: 16px;\n\n      @media (max-width: 1200px) {\n        gap: 24px;\n      }\n    }\n\n    .checkbox-row, .radio-row {\n      p {\n        line-height: 114%;\n        border: none;\n      }\n    }\n  }\n\n  .modal-text {\n    font-size: 14px;\n    line-height: 20px;\n    color: #54575C;\n  }\n\n  &__swipeHandler {\n    position: absolute;\n    top: -10px;\n    left: 50%;\n    transform: translateX(-50%);\n    width: 100%;\n    height: 2px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    z-index: 2;\n    span {\n      border-radius: 8px;\n      background: #FFF;\n      width: 88px;\n      height: 2px;\n      z-index: 2;\n      display: block;\n      position: relative;\n    }\n    &::before {\n      content: \"\";\n      position: absolute;\n      bottom: -5vh;\n      left: 0;\n      right: 0;\n      width: 100%;\n      height: 30vh;\n      background: transparent;\n    }\n  }\n\n  &__top {\n    width: 100%;\n    min-height: 216px;\n    height: 55vw;\n    max-height: 420px;\n    border-radius: 16px 16px 0 0;\n    overflow: hidden;\n\n    :global {\n      .swiper {\n        height: 100%;\n        &-pagination {\n          &-bullet {\n            width: 6px;\n            height: 6px;\n            margin: 0 6px;\n            background: #D9D9D9;\n            opacity: 0.4;\n\n            &-active {\n              background: #FAFAFA;\n              opacity: 1;\n            }\n          }\n        }\n\n        &-slide {\n          width: 100%;\n          img {\n            width: 100%;\n            height: 100%;\n            object-fit: cover;\n            object-position: center;\n          }\n        }\n      }\n    }\n  }\n\n  &__roundedTop {\n    border-radius: 16px 16px 0 0;\n  }\n\n  &__body {\n    display: flex;\n    flex-direction: column;\n    gap: 16px;\n    border-radius: 16px 16px 0 0;\n    padding: 0 16px;\n\n    &_load {\n      gap: initial;\n    }\n  }\n  &__block {\n    display: flex;\n    flex-direction: column;\n    gap: 4px;\n    margin-bottom: 5px;\n\n    @media (min-width: 1200px) {\n      margin-bottom: 24px;\n    }\n  }\n\n  &__blockTitle {\n    font-size: 16px;\n    font-weight: 500;\n    line-height: 114%;\n    padding-bottom: 4px;\n\n    @media (min-width: 640px) {\n      font-size: 22px;\n    }\n\n    @media (min-width: 1200px) {\n      font-size: var(--fz-lg);\n      line-height: var(--lh-lg);\n    }\n\n    &::first-letter {\n      text-transform: capitalize;\n    }\n  }\n\n  &__blockRequired {\n    color: #f2200d;\n  }\n\n  &__submitBlock {\n    padding: 16px;\n    bottom: 0;\n    left: 50%;\n    background: #FFF;\n    z-index: 2;\n    position: sticky;\n    width: 100%;\n  }\n\n  &__submitBlockHead {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    h5 {\n      color: #151B26;\n      line-height: 114%;\n      font-size: 14px;\n      font-weight: 600;\n    }\n    p {\n      font-size: 14px;\n      font-style: normal;\n      font-weight: 600;\n      line-height: 114%;\n      letter-spacing: -0.24px;\n    }\n  }\n\n  &__submitBlockBottom {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    margin-top: 12px;\n  }\n\n  &__calc {\n    height: 44px;\n    width: 88px;\n    min-width: 88px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border-radius: 12px;\n    background: #EEE;\n    margin-right: 12px;\n  }\n\n  &__calcPlus,\n  &__calcMinus {\n    width: 16px;\n    height: 20px;\n    display: flex;\n    align-items: center;\n    &:disabled {\n      opacity: 0.5;\n    }\n  }\n\n  &__calcNum {\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 600;\n    line-height: 20px;\n    color: #000;\n    width: 32px;\n    margin: 0 4px;\n    text-align: center;\n  }\n\n  &__picker {\n    width: 100%;\n    position: relative;\n\n    img {\n      position: absolute;\n      top: 50%;\n      transform: translateY(-50%);\n      right: 10px;\n\n      @media (min-width: 640px) {\n        right: 20px;\n        width: 32px;\n        height: 32px;\n      }\n\n      @media (min-width: 1200px) {\n        width: 22px;\n        height: 22px;\n        right: 10px;\n      }\n    }\n\n    input[type=\"date\"]::-webkit-inner-spin-button,\n    input[type=\"datetime-local\"]::-webkit-inner-spin-button,\n    input[type=\"date\"]::-webkit-calendar-picker-indicator,\n    input[type=\"datetime-local\"]::-webkit-calendar-picker-indicator {\n      position: absolute;\n      top: 0;\n      left: 0;\n      width: 100%;\n      height: 100%;\n      opacity: 0;\n      -webkit-appearance: none;\n    }\n\n     input[type=\"date\"], input[type=\"datetime-local\"] {\n      -webkit-appearance: none;\n      width: -webkit-fill-available;\n     }\n\n    // Отображение placeholder у инпутов с типом даты\n    input[type=\"date\"]:not(.has_value):before, \n    input[type=\"datetime-local\"]:not(.has_value):before {\n      content: attr(placeholder);\n      color: #BEC0C2;\n      width: 100%;\n    }\n\n    // Блок для закрытия стрелки на мобилках\n    input[type=\"date\"]::after,\n    input[type=\"datetime-local\"]::after {\n      position: absolute;\n      right: 0;\n      content: \"\";\n      width: 20px;\n      height: 100%;\n      background: white;\n      border-radius: 8px;\n      border-radius: 8px;\n    }\n\n  \n\n    input {\n      width: 100%;\n      height: 40px;\n      border-radius: 8px;\n      border: 1px solid #E8ECEE;\n      background: #FFF;\n      font-size: 14px;\n      font-style: normal;\n      font-weight: 400;\n      line-height: 24px;\n      padding: 3px 10px;\n      position: relative;\n\n      @media (min-width: 640px) {\n        height: 64px;\n        padding-left: 32px;\n        font-size: 20px;\n      }\n\n      @media (min-width: 1200px) {\n        height: 38px;\n        padding-left: 10px;\n        font-size: var(--fz-md);\n        line-height: normal;\n      }\n\n      &::placeholder {\n        color: #BEC0C2;\n      }\n    }\n\n    :global {\n      .react-datepicker-wrapper {\n        width: 100%;\n      }\n    }\n  }\n\n  &__sk1,\n  &__sk2,\n  &__sk3,\n  &__sk4 {\n    border-radius: 2px;\n    height: 13px;\n    width: 100%;\n    margin-top: 8px;\n  }\n\n  &__sk2 {\n    width: 85%;\n    margin-top: 10px;\n  }\n\n  &__sk3 {\n    width: 50%;\n    margin-top: 10px;\n  }\n\n  &__sk4 {\n    width: 20%;\n    margin-top: 16px;\n    margin-bottom: 9px;\n  }\n\n  &__sk5 {\n    margin-top: 4px;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding-left: 4px;\n    padding-top: 4px;\n    padding-bottom: 12px;\n    border-bottom: 1px solid #F3F2F2;\n    span {\n      width: 14px;\n      height: 14px;\n      border-radius: 50%;\n      display: block;\n      margin-top: 4px;\n      margin-bottom: 4px;\n    }\n\n    div {\n      border-radius: 2px;\n      height: 14px;\n      width: calc(100% - 34px);\n    }\n  }\n\n  &__info {\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n  }\n\n  &__infoTitle {\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 144%;\n    color: var(--text-color);\n  }\n\n  &__infoText {\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 144%;\n    word-wrap: break-word;\n\n    a {\n      color: var(--accent-color);\n      text-decoration: underline;\n    }\n    ul, ol{\n      margin: 0;\n      padding: 0;\n      padding-left: 16px;\n    }\n\n    img {\n      max-width: 100%;\n    }\n    table {\n      border-collapse: collapse;\n      table-layout: fixed;\n      width: 100%;\n      margin: 0;\n      overflow: hidden\n    }\n\n    table td,table th {\n      min-width: 1em;\n      border: 2px solid #ced4da;\n      padding: 3px 5px;\n      vertical-align: top;\n      box-sizing: border-box;\n      position: relative\n    }\n\n    table td>*,table th>* {\n      margin-bottom: 0\n    }\n\n    table th {\n      font-weight: 700;\n      text-align: left;\n      background-color: #f1f3f5\n    }\n\n    p {\n      min-height: 20px;\n    }\n\n    & h1,\n    & h2,\n    & h3 {\n      color: #303030;\n    }\n    pre {\n      background: #2b2a2a;\n      color: #fff;\n      padding: 8px;\n      display: flex;\n      border-radius: 8px;\n      width: 100%;\n      white-space: pre-wrap;\n    }\n    code {\n      width: 100%;\n      display: block;\n      color: #fff;\n      background-color: #f1f3f5;\n    }\n  }\n\n  &__files {\n    padding-top: 8px;\n\n    :global {\n      .orderModal {\n        &__file {\n          flex-direction: row;\n          flex-wrap: nowrap;\n          padding: 8px 32px 8px 4px;\n          border-radius: 12px;\n          border: 1px solid transparent;\n          display: flex;\n          align-items: center;\n          gap: 8px;\n          position: relative;\n          transition: var(--transition);\n          margin-bottom: 8px;\n\n          img {\n            width: 15px;\n            height: 21px;\n          }\n        }\n      }\n    }\n  }\n\n  &__file {\n    display: flex;\n    flex-direction: column;\n    flex-wrap: wrap;\n    gap: 2px;\n    margin-bottom: 8px;\n    padding: 8px 32px 8px 4px;\n    background: var(--white);\n    border-radius: 12px;\n    border: 1px solid transparent;\n    position: relative;\n    transition: var(--transition);\n\n    @media (hover: hover) {\n      &:hover {\n        border-color: var(--accent-color);\n      }\n    }\n  }\n\n  &__fileContent {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    transition: var(--transition);\n\n    img {\n      max-width: 24px;\n      min-width: 24px;\n    }\n  }\n\n  &__fileIsLoading {\n    &__loader {\n      height: 3px;\n      background: #4084F8;\n    }\n  }\n\n  &__fileName {\n    font-size: var(--fz-md);\n    line-height: var(--lh-md);\n  }\n\n  &__fileSize {\n    font-size: var(--fz-sm);\n    line-height: 1;\n    color: #7A808B;\n    margin-top: 2px;\n  }\n\n  &__fileDelete {\n    margin-left: auto;\n    color: var(--error);\n  }\n\n  &__object {\n    border-radius: 12px;\n    background: #FAFAFA;\n    padding: 8px;\n    display: flex;\n    align-items: center;\n  }\n  &__objectIco {\n    width: 26px;\n    min-width: 26px;\n    height: 26px;\n    margin-right: 8px;\n  }\n  &__objectText {\n    span {\n      font-size: 14px;\n      line-height: 114%;\n      color: #7A808B;\n    }\n\n    p {\n      font-size: 16px;\n      color: #101618;\n      line-height: 23.04px;\n    }\n  }\n\n  &__objectArrow {\n    margin-left: auto;\n  }\n\n  @media (min-width: 640px) {\n\n    &__top {\n      :global {\n        .swiper {\n          &-pagination {\n            bottom: 24px;\n            &-bullet {\n              width: 12px;\n              height: 12px;\n              margin: 0 12px;\n              background: #D9D9D9;\n              opacity: 0.4;\n    \n              &-active {\n                background: #FAFAFA;\n                opacity: 1;\n              }\n            }\n          }\n        }\n      }\n    }\n\n    &__body {\n      padding: 16px 24px 0;\n    }\n\n    &__submitBlock {\n      padding: 24px;\n      margin-left: -24px;\n    }\n\n    &__submitBlockHead {\n      h5 {\n        font-size: 32px;\n      }\n\n      p {\n        font-size: 28px;\n        letter-spacing: -0.56px;\n      }\n    }\n\n    &__submitBlockBottom {\n      margin-top: 18px;\n    }\n\n    &__calc {\n      border-radius: 16px;\n      width: 195px;\n      min-width: 195px;\n      height: 76px;\n      margin-right: 16px;\n    }\n\n    &__calcNum {\n      width: 59px;\n      height: 22px;\n      margin: 0 16px;\n      font-size: 28px;\n    }\n\n    &__calcPlus,\n    &__calcMinus {\n      width: 32px;\n      height: 32px;\n      svg {\n        width: 32px;\n        height: 32px;\n      }\n    }\n  }\n  &__inputError.orderModal__inputError{\n    border-color: #F2200D;\n  }\n\n  &__time {\n    font-size: 12px;\n    padding: 2px 4px;\n    min-height: auto;\n  }\n}\n\n.photoBlock {\n  display: grid;\n  grid-gap: 8px;\n  grid-template-columns: repeat(3, 1fr);\n\n  @media (min-width: 1200px) {\n    grid-template-columns: repeat(6, 1fr);\n  }\n\n  &__append {\n    position: relative;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border-radius: 8px;\n    height: 105px;\n    cursor: pointer;\n    background: rgba(var(--accent-color-rgb), 0.1);\n\n    &.error {\n      border: 1px solid #F2200D;\n    }\n  }\n\n  &__plus {\n    width: 24px;\n    height: 24px;\n    border-radius: 50%;\n    background: var(--accent-color);\n    color: var(--accent-text-color);\n    position: absolute;\n    top: 8px;\n    right: 8px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n\n  &__preview {\n    height: 105px;\n    border-radius: 8px;\n    position: relative;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    overflow: hidden;\n\n    &>img {\n      width: 100%;\n      height: 100%;\n      object-fit: cover;\n      object-position: center;\n    }\n  }\n\n  &__close {\n    position: absolute;\n    top: 8px;\n    right: 8px;\n    width: 24px;\n    height: 24px;\n    border-radius: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    z-index: 1;\n    background: #E97676;\n  }\n\n  &__append,\n  &__preview {\n    @media (min-width: 640px) {\n      height: 140px;\n    }\n\n    @media (min-width: 1200px) {\n      height: 104px;\n    }\n  }\n\n  &__camera {\n    color: rgba(var(--accent-color-rgb), 0.45)\n  }\n}\n\nlabel.checkboxAlone {\n  @media (min-width: 1200px) {\n    flex-direction: row-reverse;\n    justify-content: flex-end;\n    padding-left: 0;\n  }\n\n  p {\n    @media (min-width: 1200px) {\n      width: auto;\n      font-weight: 500;\n      font-size: var(--fz-lg);\n      line-height: var(--lh-lg);\n      padding-top: 5px;\n      margin-right: 8px;\n    }\n  }\n}\n\n.orderModal {\n  &__block {\n    .checkboxAlone {\n      p {\n        &:last-child {\n          @media (min-width: 1200px) {\n            margin-left: 0;\n          }\n        }\n      }\n    }\n  }\n}\n\n.conditionList {\n  position: initial;\n  overflow: hidden;\n  transition: 0.15s;\n}\n\n.conditionList__container {\n  display: flex;\n  flex-direction: column;\n\n  @media (max-width: 1200px) {\n    gap: 24px;\n  }\n}\n\n.qrBlock {\n  padding: 10px;\n  border-radius: 8px;\n  font-size: 14px;\n  line-height: 20px;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  background: #EAF7EF;\n  width: max-content;\n  cursor: pointer;\n\n  svg {\n    width: 13px;\n    height: 13px;\n\n    path {\n      fill: #2DBE64;\n    }\n  }\n}\n\n.QRInput {\n  position: relative;\n\n  input:disabled {\n    background: none;\n  }\n\n  &__icon {\n    position: absolute;\n    top: calc(50% - 16px);\n    right: 10px;\n    background: none;\n  }\n}",".orderModal {\n  padding: 0;\n}\n.orderModal :global .modal__inner {\n  height: 100%;\n  border-radius: 0;\n  max-width: none;\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n}\n.orderModal :global .modal__inner .modal__header {\n  padding: 24px 16px;\n  border: none;\n}\n.orderModal :global .modal__inner .modal__body {\n  background: #FFF;\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  overflow: auto;\n  padding: 0;\n}\n.orderModal :global .modal__inner .modal__body .submitBlock {\n  margin-top: auto;\n}\n.orderModal :global .options-list {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n@media (max-width: 1200px) {\n  .orderModal :global .options-list {\n    gap: 24px;\n  }\n}\n.orderModal :global .checkbox-row p, .orderModal :global .radio-row p {\n  line-height: 114%;\n  border: none;\n}\n.orderModal .modal-text {\n  font-size: 14px;\n  line-height: 20px;\n  color: #54575C;\n}\n.orderModal__swipeHandler {\n  position: absolute;\n  top: -10px;\n  left: 50%;\n  transform: translateX(-50%);\n  width: 100%;\n  height: 2px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 2;\n}\n.orderModal__swipeHandler span {\n  border-radius: 8px;\n  background: #FFF;\n  width: 88px;\n  height: 2px;\n  z-index: 2;\n  display: block;\n  position: relative;\n}\n.orderModal__swipeHandler::before {\n  content: \"\";\n  position: absolute;\n  bottom: -5vh;\n  left: 0;\n  right: 0;\n  width: 100%;\n  height: 30vh;\n  background: transparent;\n}\n.orderModal__top {\n  width: 100%;\n  min-height: 216px;\n  height: 55vw;\n  max-height: 420px;\n  border-radius: 16px 16px 0 0;\n  overflow: hidden;\n}\n.orderModal__top :global .swiper {\n  height: 100%;\n}\n.orderModal__top :global .swiper-pagination-bullet {\n  width: 6px;\n  height: 6px;\n  margin: 0 6px;\n  background: #D9D9D9;\n  opacity: 0.4;\n}\n.orderModal__top :global .swiper-pagination-bullet-active {\n  background: #FAFAFA;\n  opacity: 1;\n}\n.orderModal__top :global .swiper-slide {\n  width: 100%;\n}\n.orderModal__top :global .swiper-slide img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  object-position: center;\n}\n.orderModal__roundedTop {\n  border-radius: 16px 16px 0 0;\n}\n.orderModal__body {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  border-radius: 16px 16px 0 0;\n  padding: 0 16px;\n}\n.orderModal__body_load {\n  gap: initial;\n}\n.orderModal__block {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  margin-bottom: 5px;\n}\n@media (min-width: 1200px) {\n  .orderModal__block {\n    margin-bottom: 24px;\n  }\n}\n.orderModal__blockTitle {\n  font-size: 16px;\n  font-weight: 500;\n  line-height: 114%;\n  padding-bottom: 4px;\n}\n@media (min-width: 640px) {\n  .orderModal__blockTitle {\n    font-size: 22px;\n  }\n}\n@media (min-width: 1200px) {\n  .orderModal__blockTitle {\n    font-size: var(--fz-lg);\n    line-height: var(--lh-lg);\n  }\n}\n.orderModal__blockTitle::first-letter {\n  text-transform: capitalize;\n}\n.orderModal__blockRequired {\n  color: #f2200d;\n}\n.orderModal__submitBlock {\n  padding: 16px;\n  bottom: 0;\n  left: 50%;\n  background: #FFF;\n  z-index: 2;\n  position: sticky;\n  width: 100%;\n}\n.orderModal__submitBlockHead {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n.orderModal__submitBlockHead h5 {\n  color: #151B26;\n  line-height: 114%;\n  font-size: 14px;\n  font-weight: 600;\n}\n.orderModal__submitBlockHead p {\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 114%;\n  letter-spacing: -0.24px;\n}\n.orderModal__submitBlockBottom {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-top: 12px;\n}\n.orderModal__calc {\n  height: 44px;\n  width: 88px;\n  min-width: 88px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 12px;\n  background: #EEE;\n  margin-right: 12px;\n}\n.orderModal__calcPlus, .orderModal__calcMinus {\n  width: 16px;\n  height: 20px;\n  display: flex;\n  align-items: center;\n}\n.orderModal__calcPlus:disabled, .orderModal__calcMinus:disabled {\n  opacity: 0.5;\n}\n.orderModal__calcNum {\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 20px;\n  color: #000;\n  width: 32px;\n  margin: 0 4px;\n  text-align: center;\n}\n.orderModal__picker {\n  width: 100%;\n  position: relative;\n}\n.orderModal__picker img {\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n  right: 10px;\n}\n@media (min-width: 640px) {\n  .orderModal__picker img {\n    right: 20px;\n    width: 32px;\n    height: 32px;\n  }\n}\n@media (min-width: 1200px) {\n  .orderModal__picker img {\n    width: 22px;\n    height: 22px;\n    right: 10px;\n  }\n}\n.orderModal__picker input[type=date]::-webkit-inner-spin-button,\n.orderModal__picker input[type=datetime-local]::-webkit-inner-spin-button,\n.orderModal__picker input[type=date]::-webkit-calendar-picker-indicator,\n.orderModal__picker input[type=datetime-local]::-webkit-calendar-picker-indicator {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  opacity: 0;\n  -webkit-appearance: none;\n}\n.orderModal__picker input[type=date], .orderModal__picker input[type=datetime-local] {\n  -webkit-appearance: none;\n  width: -webkit-fill-available;\n}\n.orderModal__picker input[type=date]:not(.has_value):before,\n.orderModal__picker input[type=datetime-local]:not(.has_value):before {\n  content: attr(placeholder);\n  color: #BEC0C2;\n  width: 100%;\n}\n.orderModal__picker input[type=date]::after,\n.orderModal__picker input[type=datetime-local]::after {\n  position: absolute;\n  right: 0;\n  content: \"\";\n  width: 20px;\n  height: 100%;\n  background: white;\n  border-radius: 8px;\n  border-radius: 8px;\n}\n.orderModal__picker input {\n  width: 100%;\n  height: 40px;\n  border-radius: 8px;\n  border: 1px solid #E8ECEE;\n  background: #FFF;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 24px;\n  padding: 3px 10px;\n  position: relative;\n}\n@media (min-width: 640px) {\n  .orderModal__picker input {\n    height: 64px;\n    padding-left: 32px;\n    font-size: 20px;\n  }\n}\n@media (min-width: 1200px) {\n  .orderModal__picker input {\n    height: 38px;\n    padding-left: 10px;\n    font-size: var(--fz-md);\n    line-height: normal;\n  }\n}\n.orderModal__picker input::placeholder {\n  color: #BEC0C2;\n}\n.orderModal__picker :global .react-datepicker-wrapper {\n  width: 100%;\n}\n.orderModal__sk1, .orderModal__sk2, .orderModal__sk3, .orderModal__sk4 {\n  border-radius: 2px;\n  height: 13px;\n  width: 100%;\n  margin-top: 8px;\n}\n.orderModal__sk2 {\n  width: 85%;\n  margin-top: 10px;\n}\n.orderModal__sk3 {\n  width: 50%;\n  margin-top: 10px;\n}\n.orderModal__sk4 {\n  width: 20%;\n  margin-top: 16px;\n  margin-bottom: 9px;\n}\n.orderModal__sk5 {\n  margin-top: 4px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding-left: 4px;\n  padding-top: 4px;\n  padding-bottom: 12px;\n  border-bottom: 1px solid #F3F2F2;\n}\n.orderModal__sk5 span {\n  width: 14px;\n  height: 14px;\n  border-radius: 50%;\n  display: block;\n  margin-top: 4px;\n  margin-bottom: 4px;\n}\n.orderModal__sk5 div {\n  border-radius: 2px;\n  height: 14px;\n  width: calc(100% - 34px);\n}\n.orderModal__info {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n.orderModal__infoTitle {\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 144%;\n  color: var(--text-color);\n}\n.orderModal__infoText {\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 144%;\n  word-wrap: break-word;\n}\n.orderModal__infoText a {\n  color: var(--accent-color);\n  text-decoration: underline;\n}\n.orderModal__infoText ul, .orderModal__infoText ol {\n  margin: 0;\n  padding: 0;\n  padding-left: 16px;\n}\n.orderModal__infoText img {\n  max-width: 100%;\n}\n.orderModal__infoText table {\n  border-collapse: collapse;\n  table-layout: fixed;\n  width: 100%;\n  margin: 0;\n  overflow: hidden;\n}\n.orderModal__infoText table td, .orderModal__infoText table th {\n  min-width: 1em;\n  border: 2px solid #ced4da;\n  padding: 3px 5px;\n  vertical-align: top;\n  box-sizing: border-box;\n  position: relative;\n}\n.orderModal__infoText table td > *, .orderModal__infoText table th > * {\n  margin-bottom: 0;\n}\n.orderModal__infoText table th {\n  font-weight: 700;\n  text-align: left;\n  background-color: #f1f3f5;\n}\n.orderModal__infoText p {\n  min-height: 20px;\n}\n.orderModal__infoText h1, .orderModal__infoText h2, .orderModal__infoText h3 {\n  color: #303030;\n}\n.orderModal__infoText pre {\n  background: #2b2a2a;\n  color: #fff;\n  padding: 8px;\n  display: flex;\n  border-radius: 8px;\n  width: 100%;\n  white-space: pre-wrap;\n}\n.orderModal__infoText code {\n  width: 100%;\n  display: block;\n  color: #fff;\n  background-color: #f1f3f5;\n}\n.orderModal__files {\n  padding-top: 8px;\n}\n.orderModal__files :global .orderModal__file {\n  flex-direction: row;\n  flex-wrap: nowrap;\n  padding: 8px 32px 8px 4px;\n  border-radius: 12px;\n  border: 1px solid transparent;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  position: relative;\n  transition: var(--transition);\n  margin-bottom: 8px;\n}\n.orderModal__files :global .orderModal__file img {\n  width: 15px;\n  height: 21px;\n}\n.orderModal__file {\n  display: flex;\n  flex-direction: column;\n  flex-wrap: wrap;\n  gap: 2px;\n  margin-bottom: 8px;\n  padding: 8px 32px 8px 4px;\n  background: var(--white);\n  border-radius: 12px;\n  border: 1px solid transparent;\n  position: relative;\n  transition: var(--transition);\n}\n@media (hover: hover) {\n  .orderModal__file:hover {\n    border-color: var(--accent-color);\n  }\n}\n.orderModal__fileContent {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  transition: var(--transition);\n}\n.orderModal__fileContent img {\n  max-width: 24px;\n  min-width: 24px;\n}\n.orderModal__fileIsLoading__loader {\n  height: 3px;\n  background: #4084F8;\n}\n.orderModal__fileName {\n  font-size: var(--fz-md);\n  line-height: var(--lh-md);\n}\n.orderModal__fileSize {\n  font-size: var(--fz-sm);\n  line-height: 1;\n  color: #7A808B;\n  margin-top: 2px;\n}\n.orderModal__fileDelete {\n  margin-left: auto;\n  color: var(--error);\n}\n.orderModal__object {\n  border-radius: 12px;\n  background: #FAFAFA;\n  padding: 8px;\n  display: flex;\n  align-items: center;\n}\n.orderModal__objectIco {\n  width: 26px;\n  min-width: 26px;\n  height: 26px;\n  margin-right: 8px;\n}\n.orderModal__objectText span {\n  font-size: 14px;\n  line-height: 114%;\n  color: #7A808B;\n}\n.orderModal__objectText p {\n  font-size: 16px;\n  color: #101618;\n  line-height: 23.04px;\n}\n.orderModal__objectArrow {\n  margin-left: auto;\n}\n@media (min-width: 640px) {\n  .orderModal__top :global .swiper-pagination {\n    bottom: 24px;\n  }\n  .orderModal__top :global .swiper-pagination-bullet {\n    width: 12px;\n    height: 12px;\n    margin: 0 12px;\n    background: #D9D9D9;\n    opacity: 0.4;\n  }\n  .orderModal__top :global .swiper-pagination-bullet-active {\n    background: #FAFAFA;\n    opacity: 1;\n  }\n  .orderModal__body {\n    padding: 16px 24px 0;\n  }\n  .orderModal__submitBlock {\n    padding: 24px;\n    margin-left: -24px;\n  }\n  .orderModal__submitBlockHead h5 {\n    font-size: 32px;\n  }\n  .orderModal__submitBlockHead p {\n    font-size: 28px;\n    letter-spacing: -0.56px;\n  }\n  .orderModal__submitBlockBottom {\n    margin-top: 18px;\n  }\n  .orderModal__calc {\n    border-radius: 16px;\n    width: 195px;\n    min-width: 195px;\n    height: 76px;\n    margin-right: 16px;\n  }\n  .orderModal__calcNum {\n    width: 59px;\n    height: 22px;\n    margin: 0 16px;\n    font-size: 28px;\n  }\n  .orderModal__calcPlus, .orderModal__calcMinus {\n    width: 32px;\n    height: 32px;\n  }\n  .orderModal__calcPlus svg, .orderModal__calcMinus svg {\n    width: 32px;\n    height: 32px;\n  }\n}\n.orderModal__inputError.orderModal__inputError {\n  border-color: #F2200D;\n}\n.orderModal__time {\n  font-size: 12px;\n  padding: 2px 4px;\n  min-height: auto;\n}\n\n.photoBlock {\n  display: grid;\n  grid-gap: 8px;\n  grid-template-columns: repeat(3, 1fr);\n}\n@media (min-width: 1200px) {\n  .photoBlock {\n    grid-template-columns: repeat(6, 1fr);\n  }\n}\n.photoBlock__append {\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 8px;\n  height: 105px;\n  cursor: pointer;\n  background: rgba(var(--accent-color-rgb), 0.1);\n}\n.photoBlock__append.error {\n  border: 1px solid #F2200D;\n}\n.photoBlock__plus {\n  width: 24px;\n  height: 24px;\n  border-radius: 50%;\n  background: var(--accent-color);\n  color: var(--accent-text-color);\n  position: absolute;\n  top: 8px;\n  right: 8px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.photoBlock__preview {\n  height: 105px;\n  border-radius: 8px;\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n}\n.photoBlock__preview > img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  object-position: center;\n}\n.photoBlock__close {\n  position: absolute;\n  top: 8px;\n  right: 8px;\n  width: 24px;\n  height: 24px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1;\n  background: #E97676;\n}\n@media (min-width: 640px) {\n  .photoBlock__append, .photoBlock__preview {\n    height: 140px;\n  }\n}\n@media (min-width: 1200px) {\n  .photoBlock__append, .photoBlock__preview {\n    height: 104px;\n  }\n}\n.photoBlock__camera {\n  color: rgba(var(--accent-color-rgb), 0.45);\n}\n\n@media (min-width: 1200px) {\n  label.checkboxAlone {\n    flex-direction: row-reverse;\n    justify-content: flex-end;\n    padding-left: 0;\n  }\n}\n@media (min-width: 1200px) {\n  label.checkboxAlone p {\n    width: auto;\n    font-weight: 500;\n    font-size: var(--fz-lg);\n    line-height: var(--lh-lg);\n    padding-top: 5px;\n    margin-right: 8px;\n  }\n}\n\n@media (min-width: 1200px) {\n  .orderModal__block .checkboxAlone p:last-child {\n    margin-left: 0;\n  }\n}\n\n.conditionList {\n  position: initial;\n  overflow: hidden;\n  transition: 0.15s;\n}\n\n.conditionList__container {\n  display: flex;\n  flex-direction: column;\n}\n@media (max-width: 1200px) {\n  .conditionList__container {\n    gap: 24px;\n  }\n}\n\n.qrBlock {\n  padding: 10px;\n  border-radius: 8px;\n  font-size: 14px;\n  line-height: 20px;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  background: #EAF7EF;\n  width: max-content;\n  cursor: pointer;\n}\n.qrBlock svg {\n  width: 13px;\n  height: 13px;\n}\n.qrBlock svg path {\n  fill: #2DBE64;\n}\n\n.QRInput {\n  position: relative;\n}\n.QRInput input:disabled {\n  background: none;\n}\n.QRInput__icon {\n  position: absolute;\n  top: calc(50% - 16px);\n  right: 10px;\n  background: none;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"orderModal": `styles_orderModal__On4U2`,
	"modal-text": `styles_modal-text__XKp0h`,
	"orderModal__swipeHandler": `styles_orderModal__swipeHandler__-h3ls`,
	"orderModal__top": `styles_orderModal__top__XfjsF`,
	"orderModal__roundedTop": `styles_orderModal__roundedTop__gm0+I`,
	"orderModal__body": `styles_orderModal__body__TTwMb`,
	"orderModal__body_load": `styles_orderModal__body_load__3OQkQ`,
	"orderModal__block": `styles_orderModal__block__jBEcc`,
	"orderModal__blockTitle": `styles_orderModal__blockTitle__UsqbI`,
	"orderModal__blockRequired": `styles_orderModal__blockRequired__jKtsS`,
	"orderModal__submitBlock": `styles_orderModal__submitBlock__jJxeN`,
	"orderModal__submitBlockHead": `styles_orderModal__submitBlockHead__Hd8mi`,
	"orderModal__submitBlockBottom": `styles_orderModal__submitBlockBottom__XNHxK`,
	"orderModal__calc": `styles_orderModal__calc__NPqWj`,
	"orderModal__calcPlus": `styles_orderModal__calcPlus__6AYWk`,
	"orderModal__calcMinus": `styles_orderModal__calcMinus__BkfMy`,
	"orderModal__calcNum": `styles_orderModal__calcNum__BQMkR`,
	"orderModal__picker": `styles_orderModal__picker__DcQkc`,
	"has_value": `styles_has_value__GS-kq`,
	"orderModal__sk1": `styles_orderModal__sk1__9L5dA`,
	"orderModal__sk2": `styles_orderModal__sk2__pxthQ`,
	"orderModal__sk3": `styles_orderModal__sk3__IzHAF`,
	"orderModal__sk4": `styles_orderModal__sk4__HNE-Y`,
	"orderModal__sk5": `styles_orderModal__sk5__hCBms`,
	"orderModal__info": `styles_orderModal__info__M87-b`,
	"orderModal__infoTitle": `styles_orderModal__infoTitle__06LKb`,
	"orderModal__infoText": `styles_orderModal__infoText__06jra`,
	"orderModal__files": `styles_orderModal__files__LnGzv`,
	"orderModal__file": `styles_orderModal__file__nn+Qh`,
	"orderModal__fileContent": `styles_orderModal__fileContent__0wwD7`,
	"orderModal__fileIsLoading__loader": `styles_orderModal__fileIsLoading__loader__Hdhih`,
	"orderModal__fileName": `styles_orderModal__fileName__W+QOa`,
	"orderModal__fileSize": `styles_orderModal__fileSize__nmoTc`,
	"orderModal__fileDelete": `styles_orderModal__fileDelete__NtCSF`,
	"orderModal__object": `styles_orderModal__object__RfzNV`,
	"orderModal__objectIco": `styles_orderModal__objectIco__Gjc9a`,
	"orderModal__objectText": `styles_orderModal__objectText__PmtL-`,
	"orderModal__objectArrow": `styles_orderModal__objectArrow__FTppE`,
	"orderModal__inputError": `styles_orderModal__inputError__KPVxs`,
	"orderModal__time": `styles_orderModal__time__n-Ko9`,
	"photoBlock": `styles_photoBlock__UY68P`,
	"photoBlock__append": `styles_photoBlock__append__UiuDU`,
	"error": `styles_error__25j67`,
	"photoBlock__plus": `styles_photoBlock__plus__4qG7t`,
	"photoBlock__preview": `styles_photoBlock__preview__OTEa6`,
	"photoBlock__close": `styles_photoBlock__close__6-S9E`,
	"photoBlock__camera": `styles_photoBlock__camera__oyviF`,
	"checkboxAlone": `styles_checkboxAlone__0iloR`,
	"conditionList": `styles_conditionList__PCqEU`,
	"conditionList__container": `styles_conditionList__container__5kG-A`,
	"qrBlock": `styles_qrBlock__u-+9B`,
	"QRInput": `styles_QRInput__KjW+e`,
	"QRInput__icon": `styles_QRInput__icon__dpmkP`
};
export default ___CSS_LOADER_EXPORT___;
